export default __webpack_public_path__ + "static/media/bar.3502b729.webp";